module.exports = __webpack_public_path__ + "static/media/logoHant.aa57f305.png";